module.exports = __webpack_public_path__ + "static/media/22_polished_stainless_steel_seamless.bbe0a707.jpg";